<app-redtext-view [redtextData]="selectedRedtext$ | async"
                [loading]="detailsStore.loading$ | async"
                [error]="detailsStore.searchError$ | async"
                class="mat-app-background-1">

</app-redtext-view>
